/**
 * Created by Administrator on 2018/2/24.
 */
import AxiosManager from "./apis/axios";
import UrlManager from "./apis/urls";
import WebSocketWrapper from "./apis/ents";
/**
 * baseUrl:dx.server后台url
 * wsUrl:webScok url
 * alarmUrl:预警消息服务URl
 * redirectUrl:token失效等情况下路由重定向URl
 * enterprise:企业类型（决定登录页面标题名称）
 * avatar:头像
 // * companyLogo企业logo
 * title企业大标题
 * //const alarmUrl = 'http://183.233.190.96:8700/api';//131服务器
 */
/***
 * 1:本地测试
 * 2:阿里云服务
 * 3:湖南湘银河
 * 4:贵州花溪
 * 5:单机版
 * 6:南通服务器
 *  7大铁本地测试
 *  8韶关局域网单机版
 * @type {*}
 * 长沙水渡河 于 webFrontMini 项目
 */
// let type = 'test';
let type =
  process.env.NODE_ENV === "development" ? "test" : process.env.NODE_ENV;
// const type = 1;/*本地测试*/
// const type = 'test';/*117测试服务器*/
// const type = 3;/*117服务器*/
// const type = 4;
// const type = 5;//单机版
// const type = 6;
// const type = 7
// const type = 8
// const type = 9 //集群测试
function deploys(type) {
  var baseUrl,
    wsUrl,
    alarmUrl,
    redirectUrl,
    enterprise,
    avatar,
    companyLogo,
    welcomeL,
    title,
    limit;
  switch (type) {
    case "development" /*本地测试*/:
      baseUrl = "http://127.0.0.1:8202/api"; //本地测试
      wsUrl = "ws://127.0.0.1:8202/api"; //本地测试
      alarmUrl = "http://117.48.195.5:8700/api"; //阿里云服务器
      redirectUrl = "http://localhost:8082/#/login"; //阿里云前端地址
      // redirectUrl = 'http://112.74.205.248:8600/#!/login';//阿里云前端地址
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 1;
      break;
    case "test" /*117测试服务器*/:
      baseUrl = "http://117.48.195.5:8401/api"; //117测试服务器
      // baseUrl = 'http://192.168.2.29:8202/api';
      wsUrl = "ws://117.48.195.5:8401/api"; //117正式
      alarmUrl = "http://117.48.195.5:8700/api"; //117正式
      redirectUrl = "http://117.48.195.5:8601/#/login"; //117测试服务器
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 2;
      break;
    case "production" /*117服务器*/:
      baseUrl = "http://117.48.195.5:8400/api";
      wsUrl = "ws://117.48.195.5:8400/api";
      alarmUrl = "http://117.48.195.5:8700/api";
      redirectUrl = "http://monitor.szdatie.com:8600/#/login";
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 3;
      break;
    case 4 /*贵州花溪*/:
      baseUrl = "http://112.74.205.248:8400/api"; //阿里云服务器
      wsUrl = "ws://112.74.205.248:8400/api"; //阿里云服务器
      alarmUrl = "http://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "http://112.74.205.248:9600/#!/login"; //阿里云前端地址
      enterprise = require("./assets/enterprises/enterprise-gz.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 4;
      break;
    case 5 /*单机版*/:
      baseUrl = "http://127.0.0.1:8400/api"; //单机版
      wsUrl = "ws://127.0.0.1:8400/api"; //单机版
      alarmUrl = "http://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "http://127.0.0.1:8600/#!/login"; //单机版
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 5;
      break;
    case 6 /*南通单机版*/:
      baseUrl = "http://58.221.12.130:8400/api";
      wsUrl = "ws://58.221.12.130:8400/api";
      alarmUrl = "http://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "http://58.221.12.130:8600/#!/login";
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 6;
      break;

    case 7 /*大铁测试*/:
      baseUrl = "https://183.233.190.96:8400/api";
      // baseUrl='183.233.190.96:9100/api';
      wsUrl = "ws://183.233.190.96:8400/api";
      alarmUrl = "https://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "https://183.233.190.96:8600/#/login";
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 7;
      break;
    case 8 /*韶关局域网单机版*/:
      baseUrl = "http://192.168.171.250:8400/api";
      wsUrl = "ws://192.168.171.250:8400/api";
      alarmUrl = "http://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "http://192.168.171.250:8600/#!/login";
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 8;
      break;
    case 9 /*集群测试*/:
      baseUrl = "http://112.74.205.248:9100/api";
      wsUrl = "ws://192.168.171.250:8400/api";
      alarmUrl = "http://112.74.205.248:8700/api"; //阿里云服务器
      redirectUrl = "http://192.168.171.250:8600/#!/login";
      enterprise = require("./assets/enterprises/enterprise-dt.png");
      avatar = require("./assets/avatars/avatar-dt.jpg");
      companyLogo = require("./assets/companyLogo/qrcode_258.png");
      welcomeL = "欢迎";
      title = "云监测平台";
      limit = 9;
      break;
  }
  return {
    baseUrl,
    wsUrl,
    alarmUrl,
    redirectUrl,
    enterprise,
    avatar,
    companyLogo,
    welcomeL,
    title,
    limit
  };
}

class Config {
  constructor(
    http,
    url,
    wsUrl,
    events,
    alarmUrl,
    redirectUrl,
    enterprise,
    avatar,
    companyLogo,
    welcomeL,
    title,
    limit
  ) {
    this.http = http;
    this.url = url;
    this.wsUrl = wsUrl;
    this.events = events;
    this.alarmUrl = alarmUrl;
    this.redirectUrl = redirectUrl;
    this.enterprise = enterprise;
    this.avatar = avatar;
    this.companyLogo = companyLogo;
    this.welcomeL = welcomeL;
    this.title = title;
    this.limit = limit;
  }
}

const getConfig = function() {
  var deploy = deploys(type);
  const http = AxiosManager.getAxiosManager(deploy.baseUrl);
  const url = UrlManager.getUrlManager(deploy.baseUrl);
  const wsUrl = UrlManager.getWsUrlManager(deploy.wsUrl);
  const events = new WebSocketWrapper(deploy.wsUrl + "/events");
  const alarmUrl = deploy.alarmUrl;
  const redirectUrl = deploy.redirectUrl;
  const enterprise = deploy.enterprise;
  const avatar = deploy.avatar;
  const companyLogo = deploy.companyLogo;
  const welcomeL = deploy.welcomeL;
  const title = deploy.title;
  const limit = deploy.limit;
  return new Config(
    http,
    url,
    wsUrl,
    events,
    alarmUrl,
    redirectUrl,
    enterprise,
    avatar,
    companyLogo,
    welcomeL,
    title,
    limit
  );
};
export default getConfig();



// WEBPACK FOOTER //
// ./src/main-config.js